import axios from 'axios'


const GalleryDisplay = (props) => {

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const token = JSON.parse(localStorage.getItem('token'));

    const deleteHandler = async () => {
        try {
            const res = await axios({
                method: 'DELETE',
                url: `${serverURL}/api/gallery-image/property/${props.propertyID}/image/${props.id}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })

            if (res && res.status === 200) {
                props.refresh();
            }

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className='col-lg-3 mb-30' >
            <div className='gallery-preview-box'>
                <img className='gallery-display-item-img img-fluid' src={props.src} alt='gallery' />
                <button onClick={deleteHandler} type='button' className='delete-btn' ><i className='fa fa-times'></i></button>
            </div>
        </div>
    )

}

export default GalleryDisplay;